import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface BenchmarkData {
  shop_metrics: {
    approval_rate: number | null;
    overcall_rate: number | null;
    quality_score: number | null;
    sample_size: number;
  };
  peer_metrics: {
    median_approval_rate: number | null;
    median_overcall_rate: number | null;
    median_quality_score: number | null;
    shop_count: number;
  };
  percentile_rank: number | null;
  insights: string[];
}

export function useDviBenchmarks(
  shopId: string | null,
  scope: 'local' | 'regional' | 'national' = 'regional',
  filters?: { system_category?: string; vehicle_make?: string }
) {
  return useQuery({
    queryKey: ['dvi-benchmarks', shopId, scope, filters],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('dvi-get-benchmarks', {
        body: { shop_id: shopId, scope, filters }
      });
      if (error) throw error;
      return data as BenchmarkData;
    },
    enabled: !!shopId,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}
